import { MissionWarningType } from '../enums/mission-warning-type.enum';
import type { IMissionWarning } from '../types/warning.type';

export const GIS_UNAVAILABLE_ERROR: IMissionWarning = {
  type: MissionWarningType.GIS_UNAVAILABLE,
  message:
    'Le service de calcul des distances est temporairement indisponible.\nFaites appel à votre administrateur système.\nAttention, certaines fonctionnalités peuvent être impactées.',
  severity: 'error',
} as const;
